import uniqueId from 'lodash/uniqueId';
import type { ComponentProps } from 'svelte';
import type { ShareableContainer } from '$lib/container/shareableContainer';
import WithContext from '$components/Context/WithContext.svelte';
import ConfirmModal from './ConfirmModal.svelte';

export async function showConfirmModal(params: {
    message: string;
    container: ShareableContainer;
}): Promise<boolean> {
    const parent = document.createElement('div');
    document.body.append(parent);
    let element: WithContext<ComponentProps<ConfirmModal>> | null = null;

    return new Promise<boolean>((resolve, _reject) => {
        element = new WithContext<ComponentProps<ConfirmModal>>({
            target: parent,
            props: {
                container: params.container,
                component: ConfirmModal,
                props: {
                    id: uniqueId('GoAfricaNext-ConfirmModal-'),
                    resolve,
                    message: params.message,
                },
            },
        });
    })
        .catch((e) => {
            console.error(e);
            throw e;
        })
        .finally(() => {
            element?.$destroy();
            parent.remove();
        });
}
